var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99731 9.62567C8.13581 9.62567 9.05981 8.70167 9.05981 7.56317C9.05981 6.42467 8.13581 5.50067 6.99731 5.50067C5.85881 5.50067 4.93481 6.42467 4.93481 7.56317C4.93481 8.70167 5.85881 9.62567 6.99731 9.62567ZM20.75 21.9992H5.02142L14.6533 13.9623C14.9915 13.675 15.6048 13.6763 15.9362 13.961L22.125 19.241V20.6242C22.125 21.3832 21.509 21.9992 20.75 21.9992ZM4.24731 2.74933H20.7473C21.5063 2.74933 22.1223 3.36533 22.1223 4.12433V15.6248L17.7182 11.8683C16.3569 10.7106 14.2271 10.7106 12.8782 11.8601L2.87231 20.2091V4.12433C2.87231 3.36533 3.48831 2.74933 4.24731 2.74933ZM20.75 0H4.25C1.97575 0 0.125 1.85075 0.125 4.125V20.625C0.125 22.8993 1.97575 24.75 4.25 24.75H20.75C23.0243 24.75 24.875 22.8993 24.875 20.625V4.125C24.875 1.85075 23.0243 0 20.75 0Z",
    fill: "#163663"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlace);
export default __webpack_public_path__ + "static/media/imagePlace.7eb2bcefcb2e8bb2627da3628e496b06.svg";
export { ForwardRef as ReactComponent };